// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login */
.login {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 210;
    background-color: #fff;
    top: 0;
    left: 0;
}

.login.dark {
    background-color: #121212;
}

.login-box {
    width: 600px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.login-box img {
    width: 250px;
    margin-bottom: 40px;
}

.login-box-1 {
    width: 400px;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(246, 246, 246, 1);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.login-box-1:focus-within {
    box-shadow: rgb(0 53 119 / 20%) 0px 0px 24px;
    border: 1px solid rgb(0 53 119 / 20%);
    transition: all .2s ease-in-out;
}

.login-box-1.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #3f3e3e;
}

.login-box-1 input {
    width: 350px;
    height: 35px;
    background-color: rgba(246, 246, 246, 1);
    border: none;
    outline: none;
    font-size: 15px;
}

.login-box-1.dark input {
    background: #494848;
    color: #fff;
}

.login-box-2 {
    width: 400px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.login-box-2-1 {
    width: 190px;
    height: 40px;
    border-radius: 5px;
    background-color: #003577;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.login-box-2-1.dark {
    background: #494848;
    color: #fff;
}

.login-box-2-1:hover {
    filter: brightness(1.2);
}

.login-box-2-1.dark:hover {
    background-color: #003577;
}

.login-box-2-2 {
    width: 190px;
    height: 40px;
    border-radius: 5px;
    background-color: #fff;
    color: #003577;
    border: 1px solid #003577;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.login-box-2-2:hover {
    filter: brightness(1.2);
    color: #fff;
}

.login-eye {
    cursor: pointer;
    font-size: 17px;
    color: #ccc;
    position: absolute;
    right: 20px;
}






/* verification */
.verification {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 10;
    background-color: #fff;
    top: 0;
    left: 0;
}

.verification.dark {
    background-color: #121212;
}

.verification-box {
    width: 500px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.verification-box img {
    width: 200px;
    margin-bottom: 20px;
}

.verification-box-1 {
    font-size: 40px;
    font-weight: bold;
}

.verification-box-1.dark {
    color: #fff;
}

.verification-box-2 {
    font-size: 20px;
    color: rgba(114, 114, 112, 1);
}

.verification-box-2-1 {
    font-size: 17px;
    color: rgba(114, 114, 112, 1);
    margin-bottom: 20px;
    height: 40px;
}

.verification-box-2-2 {
    font-size: 17px;
    color: rgba(114, 114, 112, 1);
    margin-bottom: 20px;
    height: 40px;
    animation: resetOut .5s linear forwards;
}

.verification-box-2-1.on {
    animation: resetIn .5s linear forwards;
}

@keyframes resetIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes resetOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

.verification-box-3 {
    font-weight: bold;
    font-size: 20px;
    color: rgba(0, 43, 255, 1);
    margin-bottom: 20px;
    text-decoration: underline;
}


/* passwordReset */
.reset-box {
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
}

.reset-box.on {
    display: none;
}

.reset-box-1 {
    width: 300px;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(246, 246, 246, 1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.reset-box-1:focus-within {
    box-shadow: rgb(0 53 119 / 20%) 0px 0px 24px;
    border: 1px solid rgb(0 53 119 / 25%);
    transition: all .2s ease-in-out;
}

.reset-box-1.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #3f3e3e;
}

.reset-box-1 input {
    width: 230px;
    height: 35px;
    background-color: rgba(246, 246, 246, 1);
    border: none;
    outline: none;
    font-size: 15px;
}

.reset-box-1.dark input {
    background: #494848;
    color: #fff;
}

.reset-box-1-btn {
    width: 90px;
    height: 40px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
}

.reset-box-1-btn.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #3f3e3e;
}

.reset-box-1-btn:hover {
    background-color: #003577;
    color: #fff;
}

.reset-box-2 {
    width: 500px;
    text-align: right;
    color: #003577;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 70px;
    margin-top: 10px;
}

.reset-box-2 span {
    cursor: pointer;
}

.reset-box-2 svg {
    padding-left: 2px;
    padding-top: 2px;
}

/* .reset-box-2-info{
    padding: 15px;
    border: 1px solid #003577;
    color: #003577;
    font-size: 14px;
    border-radius: 30px;
    margin-top: 10px;
} */`, "",{"version":3,"sources":["webpack://./src/Pages/css/login.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;;;;;;AAOA,iBAAiB;AACjB;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,0BAA0B;AAC9B;;;AAGA,kBAAkB;AAClB;IACI,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;;;;;GAOG","sourcesContent":["/* login */\r\n.login {\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: fixed;\r\n    z-index: 210;\r\n    background-color: #fff;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.login.dark {\r\n    background-color: #121212;\r\n}\r\n\r\n.login-box {\r\n    width: 600px;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.login-box img {\r\n    width: 250px;\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.login-box-1 {\r\n    width: 400px;\r\n    height: 40px;\r\n    border-radius: 5px;\r\n    background-color: rgba(246, 246, 246, 1);\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.login-box-1:focus-within {\r\n    box-shadow: rgb(0 53 119 / 20%) 0px 0px 24px;\r\n    border: 1px solid rgb(0 53 119 / 20%);\r\n    transition: all .2s ease-in-out;\r\n}\r\n\r\n.login-box-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.login-box-1 input {\r\n    width: 350px;\r\n    height: 35px;\r\n    background-color: rgba(246, 246, 246, 1);\r\n    border: none;\r\n    outline: none;\r\n    font-size: 15px;\r\n}\r\n\r\n.login-box-1.dark input {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.login-box-2 {\r\n    width: 400px;\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.login-box-2-1 {\r\n    width: 190px;\r\n    height: 40px;\r\n    border-radius: 5px;\r\n    background-color: #003577;\r\n    color: #fff;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.login-box-2-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.login-box-2-1:hover {\r\n    filter: brightness(1.2);\r\n}\r\n\r\n.login-box-2-1.dark:hover {\r\n    background-color: #003577;\r\n}\r\n\r\n.login-box-2-2 {\r\n    width: 190px;\r\n    height: 40px;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    color: #003577;\r\n    border: 1px solid #003577;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.login-box-2-2:hover {\r\n    filter: brightness(1.2);\r\n    color: #fff;\r\n}\r\n\r\n.login-eye {\r\n    cursor: pointer;\r\n    font-size: 17px;\r\n    color: #ccc;\r\n    position: absolute;\r\n    right: 20px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* verification */\r\n.verification {\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: fixed;\r\n    z-index: 10;\r\n    background-color: #fff;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.verification.dark {\r\n    background-color: #121212;\r\n}\r\n\r\n.verification-box {\r\n    width: 500px;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.verification-box img {\r\n    width: 200px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.verification-box-1 {\r\n    font-size: 40px;\r\n    font-weight: bold;\r\n}\r\n\r\n.verification-box-1.dark {\r\n    color: #fff;\r\n}\r\n\r\n.verification-box-2 {\r\n    font-size: 20px;\r\n    color: rgba(114, 114, 112, 1);\r\n}\r\n\r\n.verification-box-2-1 {\r\n    font-size: 17px;\r\n    color: rgba(114, 114, 112, 1);\r\n    margin-bottom: 20px;\r\n    height: 40px;\r\n}\r\n\r\n.verification-box-2-2 {\r\n    font-size: 17px;\r\n    color: rgba(114, 114, 112, 1);\r\n    margin-bottom: 20px;\r\n    height: 40px;\r\n    animation: resetOut .5s linear forwards;\r\n}\r\n\r\n.verification-box-2-1.on {\r\n    animation: resetIn .5s linear forwards;\r\n}\r\n\r\n@keyframes resetIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes resetOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.verification-box-3 {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    color: rgba(0, 43, 255, 1);\r\n    margin-bottom: 20px;\r\n    text-decoration: underline;\r\n}\r\n\r\n\r\n/* passwordReset */\r\n.reset-box {\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n    height: 50px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.reset-box.on {\r\n    display: none;\r\n}\r\n\r\n.reset-box-1 {\r\n    width: 300px;\r\n    height: 40px;\r\n    border-radius: 5px;\r\n    background-color: rgba(246, 246, 246, 1);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.reset-box-1:focus-within {\r\n    box-shadow: rgb(0 53 119 / 20%) 0px 0px 24px;\r\n    border: 1px solid rgb(0 53 119 / 25%);\r\n    transition: all .2s ease-in-out;\r\n}\r\n\r\n.reset-box-1.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.reset-box-1 input {\r\n    width: 230px;\r\n    height: 35px;\r\n    background-color: rgba(246, 246, 246, 1);\r\n    border: none;\r\n    outline: none;\r\n    font-size: 15px;\r\n}\r\n\r\n.reset-box-1.dark input {\r\n    background: #494848;\r\n    color: #fff;\r\n}\r\n\r\n.reset-box-1-btn {\r\n    width: 90px;\r\n    height: 40px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0 10px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n}\r\n\r\n.reset-box-1-btn.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #3f3e3e;\r\n}\r\n\r\n.reset-box-1-btn:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.reset-box-2 {\r\n    width: 500px;\r\n    text-align: right;\r\n    color: #003577;\r\n    font-size: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    padding-right: 70px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.reset-box-2 span {\r\n    cursor: pointer;\r\n}\r\n\r\n.reset-box-2 svg {\r\n    padding-left: 2px;\r\n    padding-top: 2px;\r\n}\r\n\r\n/* .reset-box-2-info{\r\n    padding: 15px;\r\n    border: 1px solid #003577;\r\n    color: #003577;\r\n    font-size: 14px;\r\n    border-radius: 30px;\r\n    margin-top: 10px;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
